import { Table, addToast } from '@octano/global-ui';
import { useRef, useState } from 'react';
import useActions from '../hooks/useActions';
import useColumns from '../hooks/useColumns';
import useTexts from '../hooks/useTexts';
import SectionsRegistrationMassiveModal, {
  SectionsRegistrationMassiveModalRef,
} from '../modals/SectionsRegistrationMassiveModal';
import UploadFailureModal, {
  UploadFailureModalRef,
} from '../modals/UploadFailureModal';
function SectionsRegistrationMassiveTable() {
  const createOrUpdateModalRef = useRef<SectionsRegistrationMassiveModalRef>(
    null,
  );
  const createOrUpdateErrorModalRef = useRef<UploadFailureModalRef>(null);
  const [fileUploadFailureId, setFileUploadFailureId] = useState<string>('');
  const onClickUpload = () => {
    createOrUpdateModalRef.current?.openModal();
  };
  const texts = useTexts();

  const actions = useActions({
    onSuccess: () => {
      addToast({
        icon: 'success',
        color: 'success',
        text: texts.modal.success,
      });
    },
    onError: (_, messsage) => {
      addToast({
        icon: 'error',
        color: 'danger',
        text: messsage ?? 'Ha ocurrido un error',
      });
    },
  });

  const openErrorModal = (id: string) => {
    setFileUploadFailureId(id);
    createOrUpdateErrorModalRef.current?.openModal();
  };

  const columns = useColumns({ onClickUpload });

  return (
    <>
      <Table
        data={[
          {
            bulkRegistrationTemplate: texts.table.bulkRegistrationTemplate,
          },
        ]}
        columns={columns}
      />
      <SectionsRegistrationMassiveModal
        ref={createOrUpdateModalRef}
        actions={actions}
        onErrorFileId={openErrorModal}
      />
      <UploadFailureModal
        ref={createOrUpdateErrorModalRef}
        fileUploadFailureId={fileUploadFailureId}
      />
    </>
  );
}

export default SectionsRegistrationMassiveTable;
